import { render } from "./NewEditMember.vue?vue&type=template&id=fb07a0c6"
import script from "./NewEditMember.vue?vue&type=script&lang=js"
export * from "./NewEditMember.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__